import type { FaireProductEntity } from "../../entity_types/product";

export const p_gdgqh4k52b: FaireProductEntity = {
  token: "p_gdgqh4k52b",
  type: "product",
  name: "Football Lace Patch Beanie - Game Day - Hat - Boys",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/1feceb97c8d0a7ec6b703d2b2ea1179b41986490139f168182aa035a2961eaa2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/04421f264d8f14a3b380bc183ed83579cbc944f9956df865f49fbc9c2e0ad178.jpeg",
    "https://cdn.faire.com/fastly/bf81e79548225545df99aa781e764eaeb7ecafa9ade06b39b683f99fd11729b1.jpeg",
    "https://cdn.faire.com/fastly/644e33cac9f09d5ae6d9e025e1e1882c618769823f22040a3c8336b317215b10.jpeg",
    "https://cdn.faire.com/fastly/4af02a3fece2889bb41f83b6247e749e03acc6c2aad20628681dbf07e3cd8af0.jpeg",
    "https://cdn.faire.com/fastly/f301a3c054818ea858190cdcd26859ee912f5f342dbecf15f07cad865bfc427d.jpeg",
  ],
  priceDollars: 16,
  description:
    "The Football Lace Patch Beanie for kids is a fun and cute accessory for celebrating Game Day!\n\nFeatures:\n*Beanie Color: Mocha\n*Patch Color: White chenille with white felt outline\n*Material: 80% Acrylic/20% Nylon\n*Fit: Youth Unisex\n*Care: Hand wash only do not iron, do not tumble dry do not bleach do not dry clean\n\nEach beanie is hand-pressed with love in our hometown warehouse.",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:44:22.311Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
